export default "__VITE_ASSET__6C0rjlbQ__"